import Config from '../config/config';

require('es6-promise').polyfill();
require('isomorphic-fetch');

export const updateAppCategories = categories => ({
  type: 'UPDATE_CATEGORIES',
  categories,
});

export const updateAppProducts = products => ({
  type: 'UPDATE_PRODUCTS',
  products,
});

export const updateAppNews = news => ({
  type: 'UPDATE_NEWS',
  news,
});

export const updateAppLocations = locations => ({
  type: 'UPDATE_LOCATIONS',
  locations,
});

export const updateAppPages = pages => ({
  type: 'UPDATE_PAGES',
  pages,
});

export const updateAppContacts = contacts => ({
  type: 'UPDATE_CONTACTS',
  contacts,
});

export const updateAppBanners = banners => ({
  type: 'UPDATE_BANNERS',
  banners,
});

export const updateAppHomeslideshows = homeslideshows => ({
  type: 'UPDATE_HOMESLIDESHOWS',
  homeslideshows,
});


export const fetchCategoryData = () => dispatch =>
  fetch(`${Config.apiUrl}/categories`)
    .then(results => results.json())
    .then((data) => {
      // console.log('dispatch updateAppCategories', data);
      dispatch(updateAppCategories(data));
    });

export const fetchProductData = () => dispatch =>
  fetch(`${Config.apiUrl}/products?_limit=999`)
    .then(results => results.json())
    .then((data) => {
      const finalData = data.sort((a, b) => {
        let a_index = a.sort_index;
        let b_index = b.sort_index;
        if(!a_index){
          a_index = 99999999;
        }
        if(!b_index){
          b_index = 99999999;
        }
        
        if(a_index === b_index){
          if (a._id > b._id) {
            return 1;
          } else if (a._id < b._id) {
            return -1;
          }
          return 0;
        }
        return a_index - b_index;
      });
      const promiseArr = [];
      finalData.forEach((product) => {
        // product.productfeatures.forEach((accessory) => {
        //   promiseArr.push(fetch(`${Config.apiUrl}/productfeature/${accessory.id}`).then(results =>
        //     results.json()));
        // });

        // sort images
        if (product.image && product.image instanceof Array) {
          product.image.sort((a, b) => {
            if (a._id > b._id) {
              return 1;
            } else if (a._id < b._id) {
              return -1;
            }
            return 0;
          });
        }
      });
      Promise.all(promiseArr).then((values) => {
        // values.forEach((elem) => {
        //   for (let i = 0; i < finalData.length; i += 1) {
        //     const { productfeatures } = finalData[i];
        //     for (let j = 0; j < productfeatures.length; j += 1) {
        //       if (productfeatures[j].id === elem.id) {
        //         productfeatures[j] = elem;
        //         return;
        //       }
        //     }
        //   }
        // });
        // console.log('dispatch updateAppProducts', finalData);
        dispatch(updateAppProducts(finalData));
      });
    });

export const fetchNewsData = () => dispatch =>
  fetch(`${Config.apiUrl}/news?_sort=date:desc`)
    .then(results => results.json())
    .then((data) => {
      // console.log('dispatch updateAppNews', data);
      dispatch(updateAppNews(data));
    });

export const fetchLocationData = () => dispatch =>
  fetch(`${Config.apiUrl}/locations?_limit=999`)
    .then(results => results.json())
    .then((data) => {
      const finalData = data.sort((a, b) => {
        let a_index = a.sort_index;
        let b_index = b.sort_index;
        if(!a_index){
          a_index = 99999999;
        }
        if(!b_index){
          b_index = 99999999;
        }
        
        if(a_index === b_index){
          if (a._id > b._id) {
            return 1;
          } else if (a._id < b._id) {
            return -1;
          }
          return 0;
        }
        return a_index - b_index;
      });
      // const finalData = data;
      // const promiseArr = data.map((location) => {
      //   const url = `https://maps.google.com/maps/api/geocode/json?address=${
      //     location.address
      //   }&key=${Config.googleMapApiKey}`;
      //   return fetch(url).then(results => results.json());
      // });
      // Promise.all(promiseArr).then((values) => {
      //   values.forEach((elem, idx) => {
      //     if(elem.results[0] && elem.results[0].geometry){
      //       finalData[idx].mapLocation = elem.results[0].geometry.location;
      //     }else{
      //       finalData[idx].mapLocation = {};
      //     }
      //   });
      //   console.log('dispatch updateAppLocations', finalData);
      //   dispatch(updateAppLocations(finalData));
      // });
      // console.log('dispatch updateAppLocations', data);
      dispatch(updateAppLocations(finalData));
    });

export const fetchPageData = () => dispatch =>
  fetch(`${Config.apiUrl}/pages`)
    .then(results => results.json())
    .then((data) => {
      // console.log('dispatch updateAppPages', data);
      dispatch(updateAppPages(data));
    });

export const fetchContactData = () => dispatch =>
  fetch(`${Config.apiUrl}/contacts`)
    .then(results => results.json())
    .then((data) => {
      // console.log('dispatch updateAppContacts', data);
      dispatch(updateAppContacts(data));
    });

export const fetchBannerData = () => dispatch =>
  fetch(`${Config.apiUrl}/banners`)
    .then(results => results.json())
    .then((data) => {
      // console.log('dispatch updateAppBanners', data);
      dispatch(updateAppBanners(data));
    });

export const fetchHomeslideshowData = () => dispatch =>
  fetch(`${Config.apiUrl}/homeslideshows?_sort=index:asc`)
    .then(results => results.json())
    .then((data) => {
      // console.log('dispatch updateAppCategories', data);
      dispatch(updateAppHomeslideshows(data));
    });


// WEBPACK FOOTER //
// ./src/actions/index.js